import { SampleFields } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/sample-fields.enum';

export const negSingleCarrierSampleFieldSet = [
  SampleFields.SampleType,
  SampleFields.EditFieldsAvailable,
];
